import { ExpirationTypeEnum } from "../biologica/stato/dataservice/dto"

export enum ReleaseStatusEnum {
    RILASCIATA = 'RILASCIATA',
    PUBBLICATA = 'PUBBLICATA',
    ARCHIVIATA = 'ARCHIVIATA',
    NON_VALIDA = 'NON_VALIDA',
    NON_VALIDA_ODC = 'NON_VALIDA_ODC',
    IDONEA = 'IDONEA',
    ESCLUSA = 'ESCLUSA',
    CANCELLATA = 'CANCELLATA',
    RECEDUTA = 'RECEDUTA',
    RINUNCIATA = 'RINUNCIATA',
    RETTIFICATA = 'RETTIFICATA',
}

export enum NotificationTypeEnum {
    PRIMA_NOTIFICA = 'PRIMA_NOTIFICA',
    NOTIFICA_VARIAZIONE = 'NOTIFICA_VARIAZIONE',
    INFORMATIZZAZIONE_DI_NOTIFICA = 'INFORMATIZZAZIONE_DI_NOTIFICA',
}

export enum NotificationVariation {
    AUMENTO_O_DIMINUZIONE_DEL_NUMERO_DI_ATTIVITA = 'AUMENTO_O_DIMINUZIONE_DEL_NUMERO_DI_ATTIVITA',
    AUMENTO_O_DIMINUZIONE_DI_SUPERFICIE_CONDOTTA = 'AUMENTO_O_DIMINUZIONE_DI_SUPERFICIE_CONDOTTA',
    AUMENTO_O_DIMINUZIONE_DEL_NUMERO_DI_UP_ZOOTECNICHE = 'AUMENTO_O_DIMINUZIONE_DEL_NUMERO_DI_UP_ZOOTECNICHE',
    CAMBIO_ODC_DI_RIFERIMENTO = 'CAMBIO_ODC_DI_RIFERIMENTO',
}

export interface NotificationDTO {
    id: string
    createdAt: Date | null
    updatedAt: Date | null
    deletedAt: Date | null
    identifier: string
    activity: string
    releaseDate: Date
    releaseStatus: ReleaseStatusEnum
    type: NotificationTypeEnum
    variation: NotificationVariation
    previousOdc: string
    selectedOdc: string
    expirationType: ExpirationTypeEnum
    notificationProtocolInfo: string
    notificationValidation: boolean
    certifiedSubsequentNotificationIssued: boolean
    regionSource: string
}

export interface GetAllNotificationDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: NotificationDTO[]
}

export interface GetAllNotificationFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    customerId?: string
}

export enum SianTypeEnum {
    SIAN = 'SIAN',
    REGIONALE = 'REGIONALE'
}
export interface NotificationsSianCreationDTO {
    sianType?: SianTypeEnum
}

export interface NotificationsSianDTO {
    notificationIdentifierCreated: string[]
    notificationIdentifierFailed: string[]
}